import React from "react";
import { Link } from "react-router-dom";
import { Book, ExternalLink, Mail, MessageCircle, Sparkles, Users, CalendarDays, FileText, Settings as SettingsIcon, Bell, Wallet } from "lucide-react";

const SECTIONS = [
  {
    id: "hyrja",
    icon: Sparkles,
    title: "1. Hyrja në Sistem",
    items: [
      ["URL e Aplikacionit", "https://shqip-dent.preview.emergentagent.com/login"],
      ["Portali Publik", "https://shqip-dent.preview.emergentagent.com/portal"],
      ["Pas hyrjes së parë, ndryshoni fjalëkalimet te Profili → Ndrysho Fjalëkalimin."],
    ],
  },
  {
    id: "rolet",
    icon: Users,
    title: "2. Rolet & Lejet",
    items: [
      ["Administrator", "Akses i plotë — çdo gjë."],
      ["Mjek", "Pacientë, Takime, Trajtime, Plan Trajtimi, Odontogram. Lexim për Faturat."],
      ["Recepsionist", "Pacientë, Takime, Faturat. Krijim takimesh dhe pagesash."],
      ["Asistent", "Lexim Pacientë + Takime. Shton trajtime."],
    ],
  },
  {
    id: "pacientet",
    icon: Users,
    title: "3. Pacientët",
    items: [
      ["Shtim", "Pacientët → '+ Pacient i Ri' → plotësoni emrin, telefonin, etj."],
      ["Filtrat financiare", "Të Gjithë / Pa Faturuar / Pa Paguar / Pjesërisht / Paguar / Parapaguar."],
      ["Kërkimi", "Kërkoni sipas emrit, mbiemrit ose telefonit."],
      ["KPI globale", "Shihni 'Faturuar', 'Paguar', 'Borxhe', 'Pa Faturuar' për gjithë klinikën."],
    ],
  },
  {
    id: "kartela",
    icon: FileText,
    title: "4. Kartela e Pacientit (10 tabe)",
    items: [
      ["Profili", "Të dhënat personale + historiku mjekësor."],
      ["Historiku", "Timeline kronologjik i të gjitha veprimeve."],
      ["Odontograma", "Klikoni mbi një dhëmb → historiku + shto trajtim të ri me Klasa I-V."],
      ["Perio Chart", "Matjet e mishit për çdo dhëmb."],
      ["Plan Trajtimi", "Procedurat e planifikuara me prioritet & kosto vlerësim."],
      ["Shënime SOAP", "Subjective / Objective / Assessment / Plan."],
      ["Skedarë", "X-ray, foto, PDF."],
      ["Trajtimet, Takimet, Faturat", "Historiku i plotë."],
      ["Banner Financiar", "Gjithmonë i dukshëm: status pagese + 4 KPI."],
    ],
  },
  {
    id: "odontogram",
    icon: FileText,
    title: "5. Odontograma & Trajtimet",
    items: [
      ["Klikim mbi dhëmb", "Hapet dialog me Historiku + Form për trajtim të ri."],
      ["Toggle", "'Trajtim i Kryer (sot)' ose 'Plan për më Vonë'."],
      ["Klasa Black I-V", "Vetëm për mbushje."],
      ["Me heqje nervi (RC)", "Kuti zgjedhjeje për trajtim kanali."],
      ["Indikatorët", "Klasa, kurorë, mungon, RC — vizatohen direkt mbi dhëmb."],
    ],
  },
  {
    id: "takimet",
    icon: CalendarDays,
    title: "6. Takimet (Kalendar)",
    items: [
      ["3 pamje", "Listë / Ditë / Javë (default)."],
      ["Krijim", "Klikoni '+' ose në një qelizë → zgjidh pacient + datë + Kohëzgjatja (15 min - 4 orë)."],
      ["Mbivendosje", "Automatikisht e bllokuar për të njëjtin mjek (mesazh 409)."],
      ["Drag & drop", "Kapni nga ⋮⋮ në cep për ta zhvendosur."],
      ["Detaje", "Klik mbi takim → dialog me telefon, WhatsApp, email, status, dhe transkriptin e AI Chat (nëse aplikohet)."],
    ],
  },
  {
    id: "ai-chat",
    icon: MessageCircle,
    title: "7. AI Asistenti Virtual",
    items: [
      ["Gjuhët", "🇦🇱 Shqip · 🇬🇧 English · 🇮🇹 Italiano (auto-detect)."],
      ["Ku ndodhet", "Te /portal (poshtë-djathtas) dhe te websait-i juaj me embed."],
      ["Çfarë bën", "Përgjigjet për shërbimet, pyet ankesën, rezervon takim, ngjit transkript."],
      ["Orari", "Hë-Pre 08-18 · Sht 09-13 · Diel mbyllur. Nuk lejon kohë të kaluara."],
      ["Konfigurim", "Cilësimet → AI Chat (model, mesazh mirëseardhjeje, etj.)."],
    ],
  },
  {
    id: "lajmerime",
    icon: Bell,
    title: "8. Lajmërimet WhatsApp",
    items: [
      ["Auto", "Sapo krijohet takim → lajmërim për doktorin."],
      ["3 metoda", "wa.me (manual) · Twilio (auto, $0.005-0.04/msg) · Meta Cloud API (auto, 1000 falas/muaj)."],
      ["Ku t'i shoh", "Paneli Kryesor (widget) ose menyja → 'Lajmërime' (historia e plotë)."],
      ["Numri për doktor", "Cilësimet → Përdoruesit → klik 'shto' tek kolona WhatsApp."],
    ],
  },
  {
    id: "faturimi",
    icon: Wallet,
    title: "9. Faturimi & Pagesat",
    items: [
      ["Krijim", "Faturimi → '+ Faturë e Re' → zgjidh pacient → shto rreshta → llogarit total."],
      ["Statuset", "Paguar / Pjesërisht / Pa Paguar (auto sipas paid vs total)."],
      ["Printim PDF", "Ikona e printerit te lista → Ctrl/Cmd+P."],
      ["Përditësim pagese", "Klik mbi faturë → modifikoni 'Paguar' → Ruaj."],
    ],
  },
  {
    id: "cilesimet",
    icon: SettingsIcon,
    title: "10. Cilësimet (7 tabe)",
    items: [
      ["Monedha & Çmimet", "ALL/EUR/USD/GBP/CHF + tabelë editimi masiv çmimesh."],
      ["Klinika", "Emri, telefon, adresa, email, zona kohore (Europe/Tirane), TVSH."],
      ["Email (SMTP)", "Konfiguro Gmail / Outlook / Mailgun. Buton 'Dërgo test'."],
      ["WhatsApp", "wa.me / Twilio / Meta Cloud API."],
      ["AI Chat", "Aktiv, model, mesazhet e mirëseardhjes në 3 gjuhë."],
      ["Embed Code", "<script> për ta vendosur AI Chat në website-in tuaj."],
      ["Përdoruesit", "Shto/fshi staf, vendos WhatsApp për doktor."],
    ],
  },
];

export default function UserGuide() {
  return (
    <div className="max-w-4xl mx-auto space-y-10 pb-10" data-testid="user-guide">
      <div>
        <div className="flex items-center gap-2 text-[#2C4C3B]">
          <Book size={18} />
          <span className="label-eyebrow">Manuali i Përdorimit</span>
        </div>
        <h1 className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl">Si ta përdorni sistemin</h1>
        <p className="mt-3 text-base text-[#5C5C5C] max-w-3xl">
          Udhëzues i shkurtër në 10 pjesë për të gjithë funksionet e Zani Dental. Për dokumentacion të plotë teknik, hapni <a className="underline text-[#2C4C3B]" href="/MANUAL_PERDORIMI.md" target="_blank" rel="noreferrer">MANUAL_PERDORIMI.md</a>.
        </p>
      </div>

      {/* Quick links */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <QuickLink to="/" icon={Sparkles} label="Paneli Kryesor" />
        <QuickLink to="/pacientet" icon={Users} label="Pacientët" />
        <QuickLink to="/takimet" icon={CalendarDays} label="Takimet" />
        <QuickLink to="/lajmerime" icon={Bell} label="Lajmërime WA" />
      </div>

      {/* Sections */}
      <div className="space-y-6">
        {SECTIONS.map((s) => (
          <section key={s.id} className="surface-card p-6" id={s.id} data-testid={`guide-section-${s.id}`}>
            <div className="flex items-center gap-2 mb-3">
              <s.icon size={16} className="text-[#2C4C3B]" />
              <h2 className="text-lg font-semibold">{s.title}</h2>
            </div>
            <dl className="space-y-2">
              {s.items.map((it, idx) => (
                Array.isArray(it) && it.length === 2 ? (
                  <div key={idx} className="grid grid-cols-1 md:grid-cols-[180px,1fr] gap-x-4 gap-y-1 py-1.5 border-b border-[#E2DFD8]/60 last:border-0">
                    <dt className="label-eyebrow self-center">{it[0]}</dt>
                    <dd className="text-sm text-[#1A1A1A]">{it[1]}</dd>
                  </div>
                ) : (
                  <div key={idx} className="text-sm text-[#5C5C5C] italic py-1">{it[0]}</div>
                )
              ))}
            </dl>
          </section>
        ))}
      </div>

      {/* FAQ */}
      <section className="surface-card p-6" id="faq">
        <h2 className="text-lg font-semibold mb-3">❓ Pyetje të Shpeshta</h2>
        <FAQ q="Si të ndryshoj fjalëkalimin?" a="Profili (menyja anësore) → Ndrysho Fjalëkalimin → vendos të riun → Ruaj." />
        <FAQ q="WhatsApp nuk po dërgohet automatikisht?" a="Kontrollo: Cilësimet → WhatsApp. Metoda duhet të jetë Twilio ose Cloud API (jo wa.me). Klikoni 'Dërgo test' për diagnostikim." />
        <FAQ q="Si t'i shtoj numrin WhatsApp doktorit?" a="Cilësimet → Përdoruesit → te kolona WhatsApp, klikoni '— shto' → vendos numër me +355... → Ruaj." />
        <FAQ q="Si ta testoj Twilio Sandbox?" a="Nga telefoni juaj dërgoni mesazh 'join <kodi>' te +1 415 523 8886. Kodin e gjeni te twilio.com/console/sms/whatsapp/sandbox." />
        <FAQ q="A mund të ndryshoj monedhën?" a="Po. Cilësimet → Monedha & Çmimet → zgjidh nga ALL/EUR/USD/GBP/CHF. Kujdes: çmimet ekzistuese NUK konvertohen automatikisht (i ndryshoni manualisht)." />
        <FAQ q="A funksionon AI Chat-i jashtë websait-it tuaj?" a="Po. Cilësimet → Embed Code → kopjoni <script> → vendoseni te websait-i juaj. Aty do shfaqet butoni notues." />
      </section>

      {/* Support */}
      <section className="surface-card p-6 bg-[#FDFBF7]">
        <h2 className="text-lg font-semibold mb-2 flex items-center gap-2"><Mail size={16} /> Suport Teknik</h2>
        <p className="text-sm text-[#5C5C5C]">
          Për çdo problem teknik ose pyetje, kontaktoni ekipin tonë.<br />
          📧 <a href="mailto:support@emergent.sh" className="text-[#2C4C3B] underline">support@emergent.sh</a>
        </p>
      </section>
    </div>
  );
}

function QuickLink({ to, icon: Icon, label }) {
  return (
    <Link to={to} className="surface-card p-4 hover:border-[#2C4C3B] hover:shadow-md transition-all flex items-center gap-3 group" data-testid={`quick-link-${to.replace(/\//g, '')}`}>
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#EAE4D9] text-[#2C4C3B] group-hover:bg-[#2C4C3B] group-hover:text-[#FDFBF7] transition-colors">
        <Icon size={16} />
      </div>
      <span className="font-medium text-sm">{label}</span>
      <ExternalLink size={12} className="ml-auto text-[#5C5C5C]" />
    </Link>
  );
}

function FAQ({ q, a }) {
  return (
    <details className="py-2 border-b border-[#E2DFD8]/60 last:border-0 group">
      <summary className="cursor-pointer font-medium text-sm flex items-center justify-between hover:text-[#2C4C3B]">
        {q}
        <span className="text-[#5C5C5C] group-open:rotate-45 transition-transform text-xl leading-none">+</span>
      </summary>
      <div className="mt-2 text-sm text-[#5C5C5C] pl-1">{a}</div>
    </details>
  );
}
